import { debounce } from 'radash'
import { useEffect } from 'react'

import { getStore } from '@/store'

import {
	draftPasswordAtom,
	passwordAtom,
	passwordEnabledAtom,
	passwordRepeatAtom,
} from './passwordDesignState'
import { saveDraftQrPassword } from './qrPasswordDraft'

const AUTOSAVE_DELAY_MS = 500

let draftWriteQueue: Promise<unknown> = Promise.resolve()

const queueDraftSave = () => {
	const result = draftWriteQueue.then(saveDraftQrPassword)
	draftWriteQueue = result.catch(() => undefined)
	return result
}

// The password is saved to the draft as it is typed, like the other step 3
// settings, so a reload can restore it
export const useAutosaveQrPassword = () => {
	useEffect(() => {
		const store = getStore()
		const save = debounce({ delay: AUTOSAVE_DELAY_MS }, () => {
			queueDraftSave().catch((error) => {
				console.error('Saving QR password automatically failed:', error)
			})
		})
		const unsubscribes = [
			passwordEnabledAtom,
			passwordAtom,
			passwordRepeatAtom,
			draftPasswordAtom,
		].map((atom) => store.sub(atom, save))
		return () => {
			save.cancel()
			unsubscribes.forEach((unsubscribe) => unsubscribe())
		}
	}, [])
}
